module.exports = __webpack_public_path__ + "img/message.17670d70.svg";